<template>
  <div class="flex flex-col gap-2.5 p-4">
    <div class="flex justify-end" v-if="showCreate">
      <button
        class="btn btn-primary btn-xs rounded"
        @click="
          router.push({
            name: 'collectionEdit',
          })
        "
      >
        <i class="iconify ic--baseline-add"></i>
        {{ $t(`collection.create`) }}
      </button>
    </div>
    <div v-if="loading" class="text-center mt-10">
      <VanLoading color="#ABABAB" />
    </div>
    <div v-else-if="collectionStore.myCollection.length === 0">
      <VanEmpty :description="$t('collection.no')" />
    </div>
    <template v-else>
      <CollectionItem
        v-for="item in collectionStore.myCollection"
        :key="item.id"
        :collection="item"
      />
    </template>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import CollectionItem from "./CollectionItem.vue";
import { useCollection } from "@/stores/collection";
import { useGlobalUser } from "@/stores/globalUser";

const loading = ref(false);
const router = useRouter();
// const list = ref<Collection[]>([]);
const props = defineProps({
  mateId: {
    type: Number,
    required: true,
  },
  edit: {
    type: Boolean,
    default: false,
  },
  showCreate: {
    type: Boolean,
    default: true,
  },
});

const collectionStore = useCollection();
const loadList = async () => {
  loading.value = true;
  if (props.mateId) {
    await collectionStore.getCollectionByMateId(props.mateId);
  } else if (useGlobalUser().isLogin) {
    await collectionStore.getMyCollection();
  }
  loading.value = false;
};

onMounted(async () => {
  loadList();
});
</script>
